import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, rem } from '@bonusly/design-system';

export interface ImageModalProps {
	imageUrl?: string;
	isOpen: boolean;
	onClose: () => void;
}

export const ImageModal: FC<ImageModalProps> = ({ imageUrl, isOpen, onClose }) => {
	const { t } = useTranslation('announcements');

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="xl">
			<ModalOverlay />
			<ModalContent>
				<ModalHeader borderBottomWidth={rem(1)} borderColor="gray.100" borderStyle="solid" color="gray.900">
					{t('carousel.image_modal_header')}
				</ModalHeader>
				<ModalCloseButton size="lg" borderRadius="full" />

				<ModalBody p={5} pb={0}>
					<Image alt={t('carousel.image_modal_image_alt')} src={imageUrl} w="100%" />
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
